import { AttachmentFolderPickerError } from '../store/schema/AttachmentFolderPickerError';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import {
    loadingAttachmentFolderFailed,
    openAttachmentFolderPicker,
} from '../actions/internalActions';

mutator(openAttachmentFolderPicker, clearError);

mutator(loadingAttachmentFolderFailed, () => {
    getStore().error = AttachmentFolderPickerError.UnableToLoadDefaultAttachmentFolder;
});

function clearError() {
    getStore().error = AttachmentFolderPickerError.None;
}
